import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.16732 15.834V4.16732C9.16732 3.70708 9.54041 3.33398 10.0007 3.33398C10.4609 3.33398 10.834 3.70708 10.834 4.16732V15.834C10.834 16.2942 10.4609 16.6673 10.0007 16.6673C9.54041 16.6673 9.16732 16.2942 9.16732 15.834Z",
			fill: "url(#paint0_linear_2482_7162)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.834 9.16732C16.2942 9.16732 16.6673 9.54041 16.6673 10.0007C16.6673 10.4609 16.2942 10.834 15.834 10.834H4.16732C3.70708 10.834 3.33398 10.4609 3.33398 10.0007C3.33398 9.54041 3.70708 9.16732 4.16732 9.16732H15.834Z",
			fill: "url(#paint1_linear_2482_7162)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_2482_7162",
			x1: 4.22715,
			y1: .472861,
			x2: 11.9423,
			y2: 16.4855,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0186BF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#01BFA7"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_2482_7162",
			x1: 4.22715,
			y1: .472861,
			x2: 11.9423,
			y2: 16.4855,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0186BF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#01BFA7"
			})]
		})] })
	]
});
export default SvgPlus;
